import { render, staticRenderFns } from "./FileECA.vue?vue&type=template&id=0bcbe47e&scoped=true"
import script from "./FileECA.vue?vue&type=script&lang=ts"
export * from "./FileECA.vue?vue&type=script&lang=ts"
import style0 from "./FileECA.vue?vue&type=style&index=0&id=0bcbe47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbe47e",
  null
  
)

export default component.exports